module.exports = __webpack_public_path__ + "img/print.db42db2b.png";